// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"644":"67fb2e6adfd4b547","1208":"97aba03e7e632a3e","2727":"3a518126e71a3a93","3710":"23dbbc789a0f623e","5050":"a20c98217aaa911f","7551":"65c7744c128373ec"}[chunkId] + ".js";
};